import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditStockModuleContext from 'contexts/EditStockModuleContext';
import { StockMovement, StockMovementType } from 'types/models/StockMovement';
import { getStockMovement } from 'services/stockMovementsServices';
import StockLossForm from 'forms/StockLossForm';
import StockAdjustmentForm from 'forms/StockAdjustmentForm';
import StockTransferForm from 'forms/StockTransferForm';
import StockProductionForm from 'forms/StockProductionForm';
import MovementStatusChip from 'components/Stock/MovementStatusChip';

export default (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const { selectedMovement } = React.useContext(EditStockModuleContext);
  const [completeStockMovement, setCompleteStockMovement] = React.useState<StockMovement | null>(null);

  const isLossMovementsPage = location.search.includes(`type=${StockMovementType.LOSS}`);
  const isAdjustmentMovementsPage = location.search.includes(`type=${StockMovementType.ADJUSTMENT}`);
  const isProductionMovementsPage = location.search.includes(`type=${StockMovementType.PRODUCTION}`);

  React.useEffect(() => {
    if (!selectedMovement) {
      history.replace('/private/stock/movements');
      return;
    }

    let mounted = true;

    (async () => {
      const item = await getStockMovement(selectedMovement.id);

      if (!mounted) return;

      if (!item) {
        history.replace('/private/stock/movements');
        return;
      }

      setCompleteStockMovement(item);
    })();

    return () => {
      mounted = false;
    };
  }, [selectedMovement, history]);

  if (!selectedMovement) return <></>;
  if (!completeStockMovement) return <div>{t('loading')}</div>;

  const statusChip = <MovementStatusChip status={completeStockMovement.status} />;

  if (isLossMovementsPage)
    return (
      <>
        {statusChip}
        <StockLossForm movement={completeStockMovement} isReadOnly />
      </>
    );
  if (isAdjustmentMovementsPage)
    return (
      <>
        {statusChip}
        <StockAdjustmentForm movement={completeStockMovement} isReadOnly />
      </>
    );
  if (isProductionMovementsPage)
    return (
      <>
        {statusChip}
        <StockProductionForm movement={completeStockMovement} isReadOnly />
      </>
    );
  return (
    <>
      {statusChip}
      <StockTransferForm movement={completeStockMovement} isReadOnly />
    </>
  );
};
